import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/seo/SEO";

export default function NotFound() {
    return (
        <div data-testid="notfound-page" className="max-w-2xl mx-auto px-4 py-32 text-center">
            <SEO
                title="Página no encontrada"
                description="La página que buscas no existe o ha sido movida."
                path="/404"
                noIndex
            />
            <div className="text-xs uppercase tracking-widest text-[#082050]/60">Error 404</div>
            <h1 className="mt-4 text-4xl sm:text-5xl font-semibold text-[#082050] tracking-tight">
                Página no encontrada
            </h1>
            <p className="mt-4 text-[#4A5568]">
                La página que buscas no existe o ha sido movida.
            </p>
            <Link
                to="/"
                className="mt-8 inline-block bg-[#082050] text-white px-8 py-4 text-sm font-medium"
                data-testid="btn-back-home"
            >
                Volver al inicio
            </Link>
        </div>
    );
}
